module.exports = __webpack_public_path__ + "static/media/oberflex-noyerameriquet292-1200x2490.27e66653.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-noyerameriquet292-1200x2490.jpg
// module id = 1040
// module chunks = 37